import { currencies } from "../../../datas/filters";
import { useSelectCurrency } from "../../../hooks/useSelectCurrency";
import { Globe, MoreHorizontal } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export const NavigationWeb = (): JSX.Element => {
  const navigate = useNavigate();
  const { selectedCurrency, updateCurrency } = useSelectCurrency();
  const [language, setLanguage] = useState("English");

  const languages = ["English", "Spanish", "French", "German"];

  const handleLanguageChange = (lang: string) => {
    setLanguage(lang);
  };

  const handleCurrencyChange = (selectedCurrency: string) => {
    const findCurrency = currencies.find(
      (currency) => currency.currency === selectedCurrency
    );

    if (findCurrency) {
      updateCurrency(findCurrency.currency, findCurrency.locales);
    }

    navigate(0);
  };

  return (
    <div className='py-2'>
      <div className='flex flex-col-reverse md:flex-row justify-between'>
        <div className='flex flex-col text-center md:flex-row items-center gap-2 text-sm'>
          <a href='/privacy-policy'>
            <div className='relative w-fit text-zinc-600 font-semibold leading-tight'>
              Privacy Policy
            </div>
          </a>
          <a href='/'>
            <div className='relative w-fit text-zinc-600 font-semibold leading-tight'>
              Term of Use
            </div>
          </a>
          <p className='relative w-fit text-zinc-400 leading-tight'>
            {`© ${new Date().getFullYear()} All rights reserved`}
          </p>
        </div>
        <div className='grid grid-cols-2 w-full md:w-fit justify-between items-center gap-2 relative'>
          <div className='w-full md:w-24 h-11 relative'>
            <div className='left-[12.50px] top-[12px] absolute justify-center items-center gap-1.5 inline-flex'>
              <div className='text-center text-zinc-400 text-lg font-normal'>
                <Globe />
              </div>
              <div className='text-zinc-400 text-sm font-bold leading-tight'>
                {language}
              </div>
            </div>
            <select
              className='absolute inset-0 opacity-0 cursor-pointer'
              value={language}
              onChange={(e) => handleLanguageChange(e.target.value)}>
              {languages.map((lang) => (
                <option key={lang} value={lang}>
                  {lang}
                </option>
              ))}
            </select>
          </div>
          <div className='w-full md:w-20 h-11 relative'>
            <div className='left-[10.50px] top-[12px] right-[10.50px] md:right-0 absolute justify-end items-center gap-1.5 inline-flex'>
              <div className='text-center text-zinc-400 text-lg font-normal'>
                <MoreHorizontal />
              </div>
              <div className='text-zinc-400 text-sm font-bold leading-tight'>
                {selectedCurrency?.currency}
              </div>
            </div>
            <select
              className='absolute inset-0 opacity-0 cursor-pointer'
              value={selectedCurrency?.currency}
              onChange={(e) => handleCurrencyChange(e.target.value)}>
              {currencies.map((cur) => (
                <option key={cur.currency} value={cur.currency}>
                  {cur.currency}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};
